import Color from 'color'

const zentakeColor = Color('#1D8CF8')
const screenColor = Color('#F3F5F7')

const blackColor = Color('#000000')

const lightTheme = {
  colors: {
    primary: zentakeColor.hex(),
    primary200: zentakeColor.lighten(0.2).hex(),
    screen: screenColor.hex(),
    text: {
      emphasis: blackColor.alpha(0.87).toString(),
      idle: blackColor.alpha(0.54).toString(),
      disabled: blackColor.alpha(0.24).toString(),
    },
  },
}

export default lightTheme
